import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import { _delete, get, patch, putWithHeadersResponse } from "../../../server/actions";
import NotificationSystem from 'react-notification-system';
import ReactTable from 'react-table';
import { BeatLoader } from 'react-spinners';
import { _addNotification, _addNotificationError } from "../../../server/util";
import active from "../../../assets/img/active.png";
import warn from "../../../assets/img/warning.png";
import deleted from "../../../assets/img/invalid.png";
import { ENV } from '../../../server/constants';

let mealSchoolId = "";
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

class DistrictList extends Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            modalIsOpen: false,
            districtList: [],
            districtId: 0,
            districtData: [],
            search: '',
            distOpenRecId: 0
        }
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.editDistrict = this.editDistrict.bind(this);

        this.getAllDistrictList = this.getAllDistrictList.bind(this);
    }
    componentWillMount = () => {
        this.getAllDistrictList()
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    openModal(col) {
        // alert(JSON.stringify(col,null,2))
        mealSchoolId = col._links.self.href.split('/').pop();
        this.setState({ modalIsOpen: true });

    }
    getAllDistrictList = () => {
        this.setState({ loading: true })
        get('/districts?access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log("Data:::::", data);
            console.log("Data:::::", data._embedded.districts);
            // this.getSchoolCount(data)
            this.setState({
                loading: false,
                districtList: data._embedded.districts.map(item => {
                    const did = item._links.self.href.split('/').pop();
                    let primaryUser = item.districtUsers.filter(dist => dist.isPrimaryUser === true)[0] || {};
                    delete primaryUser["isActive"];
                    //const findObj = data1.response.find(x=> x.catererId == did) || {}

                    //item.schoolCount = findObj.schoolCount || 0;
                    //item.schoolNames=findObj.schoolNames||'';
                    //return {...item,...primaryUser};
                    return { ...item, ...primaryUser };
                }) || []
            }, () => {
                this.filterDistrictList()
            });
        })
            .catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get DistrictList response', error)
                }
            )
    }
    // getSchoolCount=(data)=>{
    //     get('/getCountByCategory?category=School&access_token=').then((response) => {
    //         if (!response.ok) {
    //             throw Error(response.statusText);
    //         }
    //         console.log('response', response);
    //         return response.json();
    //     }).then(data1 => {

    //        this.setState({ loading:false, 
    //             districtList: data._embedded.district.map(item=>{
    //                 console.log("districtList::::::::::",data._embedded.district);
    //                 const did = item._links.self.href.split('/').pop();
    //                 let primaryUser=item.districtUsers.filter(dist=>dist.isPrimaryUser===true)[0]||{};
    //                 const findObj = data1.response.find(x=> x.districtId == did) || {}

    //                 item.schoolCount = findObj.schoolCount || 0;
    //                 item.schoolNames=findObj.schoolNames||'';
    //                 return {...item,...primaryUser};
    //             })||[]
    //         },()=>{
    //             this.filterDistrictList()
    //         });
    //     })
    //     .catch(
    //         (error) => {
    //             this.setState({loading:false})
    //             console.log('Get SchoolList response', error)
    //         }
    //     )
    // }
    editDistrict = (row, action) => {
        let id = 0;
        if (row) {
            id = row._links.self.href.split("/").pop();
            setTimeout(() => {
                this.context.router.history.push('/superAdmin/districtRecord/' + id)
            }, 1000);
        }
    }
    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }
    closeModal() {
        this.setState({ modalIsOpen: false });
    }
    deleteDistrict = () => {
        alert("delete");
    }
    sendAdminLinks = (username) => {
        this.setState({ loading: true });
        //alert(col._links.self.href.split('/').pop())       
        get('/districtAccActivation?' + 'username=' + username + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('Successfully sent emails.', this);
            this.setState({ loading: false });
            console.log('Access Links Sent', data);
        }).catch(
            (error) => {
                this.setState({ loading: false }, () => {
                    _addNotificationError('Send links failed. Please try again later.', this);
                });
            });
    };
    restoreDistrict = (col) => {
        this.setState({ loading: true });
        let body = JSON.stringify({
            "isActive": true
        });
        let mealSchoolId = col._links.self.href.split('/').pop();
        patch(`/districts/${mealSchoolId}?access_token=`, body).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            _addNotification("District restored Successfully.", this)
            //this.getDeletedSchools()
            this.getAllDistrictList();
            this.setState({ loading: false });
        })
            .catch(
                (error) => {
                    _addNotification("Restore task failed. Please try again later.", this)
                    this.setState({ loading: false });
                    console.log('Restore District response', error)
                }
            )
    }
    districtUser = (dId) => {
        this.setState({ distOpenRecId: dId });
        const url = `/registerAsDistrictUser/${dId}?access_token=`;
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        putWithHeadersResponse(url, undefined, headers)
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((data) => {
                const url = ENV == "Development" ? `${window.location.protocol}//devdistrict${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}` : ENV == "Production" ? `${window.location.protocol}//district${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}` : `${window.location.protocol}//qadistrict${window.location.host.substr(window.location.host.indexOf('.'), window.location.host.length)}`
                window.open(
                    `${url}`,
                    '_blank' // <- This is what makes it open in a new window.
                );
                this.setState({ distOpenRecId: 0 });

            }).catch(error => {
                this.setState({ loading: false, distOpenRecId: 0 });
                _addNotificationError('Could not updated district data.', this);
            });
    }

    deleteDistrict = () => {
        this.setState({ loading: true });
        //console.log("mealSchoolId::::",mealSchoolId);
        _delete(`/districts/${mealSchoolId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification("District Deleted Successfully.", this)
            this.setState({ loading: false, modalIsOpen: false });
            this.getAllDistrictList();
        })
            .catch(
                (error) => {
                    _addNotification("Delete task failed. Please try again later.", this)
                    this.setState({ loading: false });
                    console.log('Delete District response', error)
                }
            )
    }
    getColumns = () => {


        const columns = [

            {
                Header: 'DISTRICT NAME',
                width: 300,

                Cell: ({ row }) => {
                    const sid = row._original._links.self.href.split("/").pop();
                    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <a href="javascript:void(0);" style={{ cursor: 'pointer' }} className="text-info"
                            onClick={() => { this.editDistrict(row._original, "EDIT") }}>
                            {row._original.name}</a>
                        <a href="javascript:void(0);" title="Admin URL" onClick={() => {
                            const cid = isNaN(Number(sid)) ? 0 : Number(sid);
                            if (this.state.distOpenRecId == 0) {
                                this.districtUser(cid);
                            }
                        }}><i className="fa fa-external-link" style={{ fontSize: '18px' }} aria-hidden="true"></i></a>
                    </div>
                }
            },

            //   {
            //     Header: 'No.Of Schools',
            //     accessor: 'schoolCount',
            //     width: 150            
            //   },
            //   {
            //     Header: 'Schools',
            //     Cell:({row})=>{
            //         const item=row._original;
            //         return <ul>{(item.schoolNames||'').split(',').map(school=>{
            //             return <li>{school}</li>
            //         })}</ul>
            //     },
            //     width: 300
            //   },
            {
                Header: 'DISTRICT ADMIN',
                Cell: ({ row }) => {
                    const item = row._original;
                    return <span>{(item.lastName || '') + ' ' + (item.firstName || '')}</span>
                },
                width: 300
            },
            {
                Header: "EMAIL",
                Cell: ({ row }) => {
                    const item = row._original;
                    return (<Fragment>
                        <span>
                            <img alt="action"
                                src={item.isActive ? active : warn}
                                style={{
                                    paddingRight: '5px',
                                    cursor: 'pointer',
                                    width: '22px'
                                }} />
                            {item.username}
                            {
                                item.isVerified === true ? null :
                                    (!item.isActive) ? (<a title="Disabled"><i
                                        className="fa fa-paper-plane-o" style={{ 'font-size': '14px', color: '#f44336', padding: '5px', pointerEvents: 'none', cursor: 'not-allowed' }} /></a>) : (<a title="click to link" onClick={() => this.sendAdminLinks(item.username)}><i
                                            className="fa fa-paper-plane-o" style={{ 'font-size': '14px', color: '#84bed6', padding: '5px', cursor: 'pointer' }} /></a>)
                            }
                        </span>
                    </Fragment>)
                }

            },
            {
                Header: 'ACTION',
                width: 100,
                Cell: ({ row }) => {
                    //const sid=row._original._links.self.href.split('/').pop();
                    return (<Fragment>
                        {(!row._original.isActive) ? <a title="edit" href="javascript:void(0);" style={{ pointerEvents: 'none', cursor: 'not-allowed' }} className="edit-btn"
                            onClick={() => { this.editDistrict(row._original, "EDIT") }}>
                            <i className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon" /></a> : <a title="edit" href="javascript:void(0);" style={{ cursor: 'pointer' }} className="edit-btn"
                                onClick={() => { this.editDistrict(row._original, "EDIT") }}>
                            <i className="fa fa-pencil tbl-rounded-icon bg-color-2 fa-icon" /></a>}

                        {
                            (!row._original.isActive) ? <a title="restore" href="javascript:void(0);" style={{ cursor: 'pointer' }} className="delete-btn"
                                onClick={() => { this.restoreDistrict(row._original) }}>
                                <i className="fa fa-refresh tbl-rounded-icon bg-color-5 fa-icon" /></a> : <a title="delete" href="javascript:void(0);" className="delete-btn" style={{ cursor: 'pointer' }} onClick={() => this.openModal(row._original)}>
                                <i className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" /></a>
                        }
                    </Fragment>)
                }
            }];
        return columns
    }
    filterDistrictList = () => {
        let data = [];
        const { search, districtList } = this.state;
        if (search.length > 0) {
            districtList.forEach(obj => {
                if (obj.name != null && (obj.name.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.firstName != null && (obj.firstName.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.lastName != null && (obj.lastName.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                } else if (obj.username != null && (obj.username.toLowerCase()).startsWith(search.toLowerCase())) {
                    data.push(obj);
                }
                else if ((obj.schoolNames || '').length > 0) {
                    let x = false;
                    (obj.schoolNames || '').split(',').forEach(school => {
                        if (school.toLowerCase().startsWith(search.toLowerCase())) {
                            x = true;
                        }

                    });
                    x === true ? data.push(obj) : '';
                }
            });
        } else {
            data = districtList;
        }
        this.setState({ districtData: data })
    }
    render() {
        return (<Fragment>
            <NotificationSystem ref="notificationSystem" />
            <section className=" full-width clearfix">
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container-full">
                    <div className="sectionTitle">
                        <h2>
                            <span>Districts</span>
                        </h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 form-group">
                            <input type="text" id="search" className="search form-control" value={this.state.search}
                                name="search" placeholder="Search.." onChange={(e) => {
                                    this.setState({ search: e.target.value }, () => {
                                        this.filterDistrictList()
                                    });
                                }} autocomplete='off'
                            />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12 button-group-section form-group">
                            <Link className="btn btn-success button-sm add-btn-sm"
                                id="addDistrict" onClick={() => { this.editDistrict(null, "NEW") }}
                                to="/superAdmin/districtRecord"><i className="fa fa-plus" /> Add District</Link>
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="table-responsive">
                            <Modal
                                isOpen={this.state.modalIsOpen}
                                onAfterOpen={this.afterOpenModal}
                                onRequestClose={this.closeModal}
                                style={customStyles}
                                contentLabel="Activation"
                            >
                                <div className="modal-header">
                                    <h4 className="modal-title modal-title-color" id="deleteLabel">Delete
                                        District</h4>
                                </div>
                                <div className="modal-body">
                                    <p>Are you sure you want to delete this District from Meal Manage service?<br />
                                        <b><i>You can restore District again from deleted District tab</i></b></p>
                                </div>
                                <div className="modal-footer">
                                    <form>
                                        <button type="button" className="btn btn-sm btn-success"
                                            onClick={() => this.setState({ modalIsOpen: false })}
                                            style={{ margin: 0, fontSize: 14 }}><i
                                                className="glyphicon glyphicon-remove" /> Cancel
                                        </button>
                                        <button type="button" className="btn btn-sm btn-danger"
                                            onClick={this.deleteDistrict}
                                            style={{ margin: 0, marginLeft: 5, fontSize: 14 }}><i
                                                className="glyphicon glyphicon-ok" /> Delete
                                        </button>
                                    </form>
                                </div>
                            </Modal>
                        </div>
                        <div className="row">
                            <div className='col-md-12'>
                                <div className="clearfix"></div>
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <ReactTable
                                            data={this.state.districtData}
                                            columns={this.getColumns()}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                            noDataText='No data found'
                                            sortable={true}
                                            defaultSorting={[{
                                                id: 'session',
                                                desc: false
                                            }]}
                                            minRows={1}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Fragment>);
    }
}
DistrictList.contextTypes = {
    router: PropTypes.object.isRequired
}

export default DistrictList;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/district/districtList.jsx